/* global google */
import React, { useContext } from "react";
import { Map, GoogleApiWrapper, Marker, Circle } from "google-maps-react";
import Markers from "../Markers";
import { GlobalContext } from "./../Context";
import "./Map.scss";
import currentLocationIcon from "../../../assets/img/current-location.svg"; // ToDo: Add current location animation

function MapContainer(props) {
  const globalContext = useContext(GlobalContext);
  const {
    setCurrentPopUp,
    radius,
    branches,
    currentBranch,
    setCurrentBranch,
    initialPos,
    setMapsInstance,
    markersVisibility,
    langcode
  } = globalContext;
  const displayCircle = () => {
    return (
      <Circle
        radius={radius}
        center={initialPos}
        strokeColor="#1075BB"
        strokeOpacity={1}
        strokeWeight={1}
        fillColor="#1075BB"
        fillOpacity={0.2}
      />
    );
  };

  let mapZoom;
  if (window.innerWidth < 767) {
    mapZoom = 14;
  } else {
    mapZoom = 15;
  }

  return (
    <div className="map__wrapper">
      <div className={`map__opacity ${branches.length ? "map__opacity--hide" : ""}`}></div>
      <Map
        google={props.google}
        zoom={mapZoom}
        className="map"
        initialCenter={initialPos}
        center={initialPos}
        key="map"
        onReady={(mapsProps, map) => {
          setMapsInstance(mapsProps.google, map);
        }}
      >
        <Marker
          key="currentMarker"
          name="currentPosition"
          position={initialPos}
          icon={{
            url: currentLocationIcon,
            anchor: new google.maps.Point(32, 32),
            scaledSize: new google.maps.Size(34, 34),
          }}
        />

        {markersVisibility && [
          Markers(
            setCurrentPopUp,
            branches,
            currentBranch,
            setCurrentBranch,
            langcode
          ),
          displayCircle(),
        ]}
      </Map>
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyChuWS7Ei6vqTAIv7-AOxKNhW2XdMNnr6k",
  libraries: ["geometry", "places"]
})(MapContainer);
